import React from "react"
import { cn } from "../../lib/utils"
import DOMPurify from "isomorphic-dompurify"

export interface HtmlContentRendererProps {
  content: string
  contentType?: "plain" | "html"
  className?: string
}

const sanitizeHtml = (html: string): string => {
  return DOMPurify.sanitize(html, {
    USE_PROFILES: {
      html: true
    }
  })
}

export function HtmlContentRenderer({ content, contentType = "html", className }: HtmlContentRendererProps) {
  if (contentType === "html") {
    const sanitizedContent = sanitizeHtml(content)

    return (
      <>
        {/* Inline CSS to ensure WYSIWYG behavior - isolated to this component */}
        <style>{`
          .html-content-renderer p {
            margin: 0.5em 0;
            line-height: 1.4;
          }
          .html-content-renderer ul {
            margin: 0.5em 0;
            padding-left: 1.5em;
            list-style-type: disc;
          }
          .html-content-renderer ol {
            margin: 0.5em 0;
            padding-left: 1.5em;
            list-style-type: decimal;
          }
          .html-content-renderer li {
            margin: 0.2em 0;
            line-height: 1.4;
          }
          .html-content-renderer strong, .html-content-renderer b {
            font-weight: bold;
          }
          .html-content-renderer em, .html-content-renderer i {
            font-style: italic;
          }
          .html-content-renderer u {
            text-decoration: underline;
          }
          .html-content-renderer a {
            color: #0066cc;
            text-decoration: underline;
          }
          .html-content-renderer a:hover {
            color: #004499;
          }
          .html-content-renderer br {
            display: block;
            margin: 0.2em 0;
            content: "";
          }
          /* Remove any external styling interference */
          .html-content-renderer * {
            box-sizing: border-box;
          }
        `}</style>
        <div
          className={cn("html-content-renderer", className)}
          dangerouslySetInnerHTML={{ __html: sanitizedContent }}
        />
      </>
    )
  }

  // Plain text - preserve line breaks
  return (
    <div className={cn("plain-content-renderer", className)} style={{ whiteSpace: 'pre-wrap' }}>
      {content}
    </div>
  )
}
